export default __webpack_public_path__ + "static/media/wSweats_1_c3.47be11c7.jpeg";